import { useState, useEffect } from 'react';
import { Background, Form, Title, Button, CloseIcon } from './style';
import InputLabel from '../../../InputLabel';
import SelectLabel from '../../../SelectLabel';
import api from '../../../../services/api';
import { Swal } from '../../../../services/SwalTemplates';
import { userId } from '../../../../services/TokenData';
import Texts from '../../../../assets/json/texts.json';
import { difference } from '../../../../services/DateFormatter';
import alert from '../../../../utils/alert';

export default function EditProcesso({ Show, setShow, Dados, setReload, Reload }) {
    const [Assunto, setAssunto] = useState('');
    const [DataEntrada, setDataEntrada] = useState('');
    const [DataInicio, setDataInicio] = useState('');
    const [DataTermino, setDataTermino] = useState('');
    const [DiasAmarelo, setDiasAmarelo] = useState(0);
    const [DiasVermelho, setDiasVermelho] = useState(0);
    const [Responsaveis, setResponsaveis] = useState([]);
    const [IdResponsaveis, setIdResponsaveis] = useState([]);
    const [IdResponsavel, setIdResponsavel] = useState(0);
    const [NovaSituacao, setNovaSituacao] = useState('');
    const UserId = userId();
    const PorcentagemAmarelo = 0.2;
    const PorcentagemVermelho = 0.1;

    useEffect(() => {
        if (Dados) {
            setAssunto(Dados?.assunto);
            setDataEntrada(Dados?.data_entrada);
            setIdResponsavel(Dados?.responsavel);
            setDataInicio(Dados?.data_inicio);
            setDataTermino(Dados?.data_prevista);
            setDiasAmarelo(Dados?.dias_para_amarelo);
            setDiasVermelho(Dados?.dias_para_vermelho);
        }
    }, [Dados]);

    useEffect(() => {
        const dias = difference({
            DataInicial_1: DataInicio,
            DataInicial_2: DataTermino,
        });
        setDiasAmarelo(Math.max(Math.ceil(dias * PorcentagemAmarelo), 2));
        setDiasVermelho(Math.max(Math.ceil(dias * PorcentagemVermelho), 1));
    }, [DataInicio, DataTermino]);

    useEffect(() => {
        async function Request() {
            api.get(`/user/usuarios`).then((response) => {
                setResponsaveis(response.data.usuarios.filter((u) => u.perfil !== 'ADM').map((r) => r.nome));
                setIdResponsaveis(response.data.usuarios.filter((u) => u.perfil !== 'ADM').map((r) => r.id));
            });
        }

        Request();
    }, []);

    async function HandleSubmit(e) {
        e.preventDefault();

        const data = {
            numero: Dados?.numero,
            assunto: Assunto,
            responsavel: IdResponsavel,
            situacao: 'Executando',
            data_prevista: DataTermino,
            data_entrada: DataEntrada,
            data_inicio: DataInicio,
            dias_para_amarelo: DiasAmarelo,
            dias_para_vermelho: DiasVermelho,
            id_usuario_acao: UserId,
        };

        api.patch(`/processos/${Dados?.id}`, { data })
            .then((response) => {
                alert('Sucesso-popup', 'Sucesso!', 3000, '', '', 'top-end', 'fit-content');
                setShow(false);
                setReload((prev) => !prev);

                if (NovaSituacao !== '') {
                    const data1 = {
                        data_conclusao: NovaSituacao === 'Concluído' ? new Date() : null,
                        data_espera: NovaSituacao === 'Aguardando' ? new Date() : null,
                        situacao: NovaSituacao === '' ? Dados.situacao : NovaSituacao,
                        id_remetente: UserId,
                        id_destinatario: IdResponsavel,
                        id_usuario_acao: UserId,
                    };

                    api.patch(`/processos/${Dados?.id}/situacao`, { data: data1 })
                        .then((response) => {
                            alert('Sucesso-popup', 'Sucesso!', 3000, '', '', 'top-end', 'fit-content');
                            setShow(false);
                            setReload((prev) => !prev);
                        })
                        .catch((e) => {
                            console.log(e);
                            Swal.fire({ title: 'Atenção!', text: 'Error', icon: 'error' });
                        });
                }
            })
            .catch((e) => {
                console.log(e);
                Swal.fire({ title: 'Atenção!', text: 'Error', icon: 'error' });
            });
    }

    const calculaData = difference({
        DataInicial_1: DataInicio,
        DataInicial_2: DataTermino,
    });

    return (
        <Background Show={Show}>
            <Form onSubmit={HandleSubmit}>
                <CloseIcon onClick={() => setShow(false)} />
                <Title>Editar Processo</Title>
                <InputLabel type="text" value={Assunto} onChange={(e) => setAssunto(e.target.value)} label="Assunto" required />
                <InputLabel type="date" value={DataEntrada} onChange={(e) => setDataEntrada(e.target.value)} label="Data Entrada" required />
                <SelectLabel
                    label="Responsável"
                    value={IdResponsavel}
                    onChange={(e) => setIdResponsavel(e.target.value)}
                    defaultValue="Responsável"
                    options={Responsaveis}
                    values={IdResponsaveis}
                />
                <InputLabel type="date" value={DataInicio} onChange={(e) => setDataInicio(e.target.value)} label="Data Inicio" required />
                <InputLabel
                    type="date"
                    value={DataTermino}
                    onChange={(e) => setDataTermino(e.target.value)}
                    label="Data Prevista para Término"
                    required
                />
                <InputLabel
                    disabled
                    type="number"
                    value={calculaData}
                    label="Dias Previstos"
                    required
                />
                <InputLabel
                    type="number"
                    value={DiasAmarelo}
                    onChange={(e) => setDiasAmarelo(e.target.value)}
                    label="Dias Alerta Amarelo"
                    min={2}
                    required
                />
                <InputLabel
                    type="number"
                    value={DiasVermelho}
                    onChange={(e) => {
                        setDiasVermelho(parseInt(e.target.value, 10) < DiasAmarelo && parseInt(e.target.value, 10) > 0 ? e.target.value : 1);
                    }}
                    label="Dias Alerta Vermelho"
                    min={1}
                    max={DiasAmarelo - 1}
                    required
                />
                <SelectLabel
                    type="text"
                    onChange={(e) => setNovaSituacao(e.target.value)}
                    label="Alterar situação do processo?"
                    defaultValue={NovaSituacao}
                    options={Texts?.STATIC_SITUACOES_PROCESSOS}
                    values={Texts?.STATIC_SITUACOES_PROCESSOS}
                />
                <Button type="submit">Salvar</Button>
            </Form>
        </Background>
    );
}
